export default "__VITE_ASSET__DQD5QRl4__"